/**
 * Módulos placeholder — aguardando integrações externas.
 * Cada um expõe ao PM exatamente: o que faz, o que tá pronto, o que falta.
 */

import { PlaceholderModule } from '@/components/PlaceholderModule';
import { useDataSources } from '@/services/datasources';

// M2 (Mapa) migrado para feature real em src/features/M2-mapa (GUPM-122).

// ── M4 — Sirenes ─────────────────────────────────────────────
export function M4Sirenes() {
  const { sirenes } = useDataSources();
  const pi = sirenes.pendingIntegration!;
  return (
    <PlaceholderModule
      modulo="M4"
      titulo="Sirenes"
      icone="📢"
      descricaoFuncional="Acionamento remoto de sirenes ZAS/ZSS (Perfil B apenas, com confirmação dupla — R-B08). Espelha o app físico de acionamento da TCal pra evitar comunicação direta com hardware."
      pending={pi}
      prontoNaPoc={[
        '3 sirenes mock (SIR-01 ZAS, SIR-02 ZAS, SIR-03 ZSS)',
        'Fluxo de acionamento manual com motivo + engineer_id',
        'Restrição RLS: só Perfil B aciona (já no schema)',
        'Registro auditável em memória (POC) — vai pra audit_log quando integrado',
      ]}
      bloqueado={[
        'URL + credencial do app TCal de sirenes',
        'Endpoint de acionamento HTTP',
        'Webhook de retorno (sirene tocou / falhou)',
        'Especificação de confirmação dupla',
      ]}
    />
  );
}

// ── M5 — Câmeras ─────────────────────────────────────────────
export function M5Cameras() {
  const { cameras } = useDataSources();
  const pi = cameras.pendingIntegration!;
  return (
    <PlaceholderModule
      modulo="M5"
      titulo="Câmeras"
      icone="📹"
      descricaoFuncional="Visualização de câmeras (TCal+Axis) e captura de frame pro M3 Via 2 (R-D04 — captura obrigatória de tela na detecção visual)."
      pending={pi}
      prontoNaPoc={[
        '4 câmeras mock (CAM-01 a CAM-04)',
        'Função capture() que retorna URL placeholder',
        'Integração com M3 Via 2 — captura é gravada em tarp_records.camera_screenshot_url',
      ]}
      bloqueado={[
        'URL do app TCal/Axis (provável embed via iframe)',
        'SSO ou credencial técnica',
        'Endpoint de captura de frame (se a TCal expor)',
      ]}
    />
  );
}

// M7 (FS Quinzenal) migrado para feature real em src/features/M7-fs-quinzenal.

// M9 (Conformidade) migrado para feature real em src/features/M9-conformidade.

// ── M11 — IA ─────────────────────────────────────────────────
export function M11Ia() {
  const { ai } = useDataSources();
  return (
    <PlaceholderModule
      modulo="M11"
      titulo="IA Embarcada"
      icone="🤖"
      descricaoFuncional="Triagem de severidade ('alarme é grave?', 'pode ser falha de sensor?' — R-C07). Pré-preenchimento de fichas de inspeção. Chatbot operacional com PAEBM indexado (futuro). Modelos Anthropic — Haiku pra leitura, Sonnet pra crítico."
      pending={ai.pendingIntegration ?? {
        owner: 'TI JFB', name: 'Chave Anthropic + indexação PAEBM',
        status: 'pendente',
        description: 'Edge Function ai-triage pronta. Aguardando secret ANTHROPIC_API_KEY pra ativar.',
      }}
      prontoNaPoc={[
        'Interface AiDataSource com mock determinístico (zero custo de tokens)',
        'Edge Function supabase/functions/ai-triage skeleton',
        'Política de classificação de dados por modelo (em domain/classificacao)',
        'Flag VITE_USE_AI_EDGE pra ativar Anthropic real quando a chave entrar',
      ]}
      bloqueado={[
        'ANTHROPIC_API_KEY em Supabase secrets',
        'PAEBM digital indexado (depende da Galvani)',
        'Treinamento JFB de prompts pro chatbot (vigilante vs técnico)',
      ]}
    />
  );
}

// M12 (Histórico de Inspeção) migrado para feature real em src/features/M12-historico.
